<template>
  <div class="header">
    <div class="logo-container">
      <img src="@/assets/logo.png">
    </div>
  </div>
</template>

<script>

export default {
  name: 'MainHeader',
  components: {
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  height: 100px;
  width: 100%;
  background-color: #101010;
  align-items: center;
  .logo-container {
    padding: 0px 25px;
    height: 100%;
    display: flex;
    align-items: center;
    img {
      width: 125px;
    }
  }
}
</style>
